module.exports = __webpack_public_path__ + "static/media/group-8.591b6b29.png";